import { render, staticRenderFns } from "./ShoppingBag.vue?vue&type=template&id=766aa93a&scoped=true&"
import script from "./ShoppingBag.vue?vue&type=script&lang=js&"
export * from "./ShoppingBag.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingBag.vue?vue&type=style&index=0&id=766aa93a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766aa93a",
  null
  
)

export default component.exports